// extracted by mini-css-extract-plugin
export var actionText = "_o6-4";
export var container = "_o6-0";
export var leftSection = "_o6-1";
export var rightSection = "_o6-2";
export var settingsButton = "_o6-6";
export var settingsIcon = "_o6-7";
export var shortcut = "_o6-5";
export var shortcutGroup = "_o6-3";